import { CSSObject } from '@chakra-ui/react';
import { TLinkContainer } from './NextToJumpItem.styles';

export const LinkContainer = ({ isLast }: TLinkContainer) => ({
  borderBottom: !isLast && '1px dashed',
  borderBottomColor: 'blackAlpha.300',
  borderRadius: 'unset',
  mb: 'unset',
  px: '2',
  w: 'auto',
  _hover: {
    bg: 'gray.200',
  },
});

export const BoxNextToJumpContainer: CSSObject = {
  bg: 'gray.50',
  borderTopRadius: 'lg',
  border: '1px',
  borderColor: 'alpha.200',
};

export const Icon: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, alpha.600)',
  borderRadius: 'base',
};

export const TextRace: CSSObject = {
  color: 'gray.700',
  fontWeight: 'medium',
};

export const TextNumber: CSSObject = {
  bg: 'alpha.700',
  h: '4',
  py: '0.5',
};

export const BoxHeading: CSSObject = {
  display: 'none',
  border: 'none',
};

export const IconHeading: CSSObject = {
  boxSize: '7',
  color: 'alpha.700',
  bg: 'white',
  borderRadius: 'lg',
  p: '1.5',
};
